// import React from "react";
// import logo from "./logo.svg";
import "./App.css";
import {
  MantineProvider,
  Container
  // ColorSchemeProvider,
  // ColorScheme,
  // Title,
  // ActionIcon,
  // Divider,
} from "@mantine/core";
// import { useState } from "react";
// import { Route, Routes } from "react-router-dom";
// import { Link } from "react-router-dom";
import Hero from "./pages/Hero";
import About from "./pages/About";
import Exp from "./pages/Experience";
import Projects from "./pages/Projects";
import End from "./pages/End";
// import { AppShell, Header, Container, Group } from "@mantine/core";
// import {
//   IconBrandInstagram,
//   IconBrandLinkedin,
//   IconBrandYoutube,
//   IconMail,
// } from "@tabler/icons";
// import { useViewportSize } from "@mantine/hooks";

function App() {
  // const [colorScheme, setColorScheme] = useState<ColorScheme>("dark");
  // const toggleColorScheme = (value?: ColorScheme) =>
  //   setColorScheme(value || (colorScheme === "dark" ? "light" : "dark"));

  // const {height, width} = useViewportSize();
  
  return (
    <div className="App">
      {/* <MantineProvider
        withGlobalStyles
        withNormalizeCSS
        theme={{
          fontFamily: "Open Sans",
          colorScheme: "dark",
          fontSizes: { md: 50 },
          radius: { sm: 200 },
          loader: "dots",
          colors: {
            basic: [
              "#ffc9c9",
              "#e03131",
              "#fcc2d7",
              "#9c36b5",
              "#6741d9",
              "#4263eb",
              "#d0ebff",
              "#96f2d7",
              "#0ca678",
              "#fd7e14",
            ],
          },
          components: {
            Button: {
              defaultProps: {
                size: "lg",
                color: "basic.9",
              },
            },
          },
        }}
      >
        <Paper>
          <Text>THIS IS A SIMPLE TEXT TAG</Text>
          <Text>THIS IS A SIMPLE TEXT TAG HEHEHEHEHEHEHE</Text>
        </Paper>
        <Loader></Loader>
        <Button> Button! </Button>
        <Button> Button! </Button>
      </MantineProvider> */}

      <MantineProvider
        withGlobalStyles
        withNormalizeCSS
        theme={{
          colorScheme: "dark",
          // fontFamily: "Greycliff CF, sans-serif",
          // headings: { fontFamily: "Greycliff CF, sans-serif" },
        }}
      >
        {/* <Routes>
              <Route path="/home" element={<Home />}>
                Home
              </Route>
              <Route path="/About" element={<About />}>
                About
              </Route>
              <Route path="/some" element={<Some />}>
                Some
              </Route>
            </Routes> */}
        {/* <AppShell
          padding="md"
          header={
            <Header height={60} p="xs">
              
              <Group position="right">
                <ActionIcon
                  color="blue.5"
                  variant="transparent"
                  size="lg"
                  component="a"
                  href="https://www.linkedin.com/in/raphaelgohwenxuan/"
                  target="_blank"
                >
                  <IconBrandLinkedin size={40} />
                </ActionIcon>

                <ActionIcon
                  color="blue.5"
                  variant="transparent"
                  size="lg"
                  component="a"
                  href="mailto:raphaelgoh.wenxuan@gmail.com"
                >
                  <IconMail size={40} />
                </ActionIcon>

                <ActionIcon
                  color="blue.5"
                  variant="transparent"
                  size="lg"
                  component="a"
                  href="https://www.youtube.com/@raphaelgoh9875/featured"
                  target="_blank"
                >
                  <IconBrandYoutube size={40} />
                </ActionIcon>
              </Group>
            </Header>
          }
        > */}
          <Container pb="xl">
            <Hero></Hero>
          </Container>
          
          

          <Container my="xl">
            <About></About>
          </Container>

          <Container my="xl">
            <Exp></Exp>
          </Container>

          <Container my="xl">
            <Projects></Projects>
          </Container>

          <Container my="xl">
            <End></End>
          </Container>
        {/* </AppShell> */}
      </MantineProvider>
    </div>
  );
}

export default App;
